import {
  Boundary,
  IconName,
  Intent,
  Menu,
  MenuItem,
  Position,
} from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import { orderBy } from "lodash-es"
import React, { useMemo } from "react"
import classNames from "utils/classNames"
import PermissionIcon from "./PermissionIcon"

type GroupPermissionsProps = {
  items?: any[]
  intent?: Intent
  className?: any
  onClick?: (item?: any, index?: number) => void
  renderText?: (item?: any, index?: number) => React.ReactNode
}
const GroupPermissions = ({
  items,
  intent,
  className,
  onClick,
  renderText = item => (item ? item.name : "na"),
}: GroupPermissionsProps) => {
  const allPermissions = useMemo(() => {
    const groups = items.map(i => ({
      ...i,
      type:
        i.codename.includes("add") || i.codename.includes("update")
          ? "edit"
          : i.codename.includes("delete")
          ? "delete"
          : "view",
    }))

    const sortedList = orderBy(groups, g => g.type, ["desc"])
    return sortedList
  }, [items])

  function renderOverflow(items) {
    return (
      <CustomPopover
        position={Position.BOTTOM}
        content={
          <Menu className="vt-overflow-list-menu">
            {items.map((item, index) => {
              const icon: IconName =
                item.type === "edit"
                  ? "edit"
                  : item.type === "delete"
                  ? "trash"
                  : "eye-on"
              return (
                <MenuItem
                  key={item.id ? item.id : `menu-item-${index}`}
                  onClick={onClick ? e => onClick(item, index) : null}
                  icon={icon}
                  text={renderText(item, index)}
                />
              )
            })}
          </Menu>
        }
      >
        <CustomTag
          className="ml-2"
          round={true}
          interactive={true}
          intent={intent}
        >
          + {items.length}
        </CustomTag>
      </CustomPopover>
    )
  }

  function renderVisible(item, index) {
    return <PermissionIcon key={item.id} permission={item}></PermissionIcon>
  }
  return (
    <CustomOverflowList
      className={classNames("vt-custom-overflow-list", className)}
      items={allPermissions}
      collapseFrom={Boundary.END}
      overflowRenderer={renderOverflow}
      visibleItemRenderer={renderVisible}
    />
  )
}

export default GroupPermissions
